// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".a139c475e262319b751b34374a3bd4d903495b60.chunk.bundle.js";
};